export * from './initApp.js'
export * from './switchView.js'
export * from './switchPhase.js'
export * from './submitForm.js'
